import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TimezoneDateProvider, UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { DialogModule } from '../dialogs/dialog.module';
import { RequiresPermissionsModule } from '../directives';
import { GenericListModule } from '../generic-list';
import { TransitProgramModule } from '../transit-program';
import { TransitProgramSelectModule } from '../transit-program-select';
import { VehicleTypeFilterModule } from '../vehicle-type-filter';
import { ReservationDetailModule } from './reservation-detail/reservation-detail.module';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatPaginatorModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ReservationDetailModule,
    UzurvPipesModule,
    UzurvDirectivesModule,
    GenericListModule,
    TransitProgramModule,
    TransitProgramSelectModule,
    VehicleTypeFilterModule,
    RequiresPermissionsModule
  ],
  providers: [TimezoneDateProvider]
})
export class ReservationModule {}
